module.exports = __webpack_public_path__ + "img/642eca31a43110176c1ef4e5d9fee0ff.f92318fa.jpg";